import { useState } from "react";
import { Button, Card, CardBody, Col } from "reactstrap";
import { CenteredModalTitle, VerticallyCentered } from "../../../../constants";
import { CenteredModalSubTitle } from "../../../../data/uiKits/Modal";
import CenteredModalBody from "./CenteredModalBody";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";

const CenteredModal = () => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  return (
    <Col xl="4">
      <Card>
        <CommonCardHeader title={CenteredModalTitle} span={CenteredModalSubTitle} />
        <CardBody>
          <Button color="success" onClick={toggle}>
            {VerticallyCentered}
          </Button>
          <CenteredModalBody modal={modal} toggle={toggle} />
        </CardBody>
      </Card>
    </Col>
  );
};
export default CenteredModal;
